'use client'

import styles from "./PhotographerHeader.module.css";
import Image from "next/image";
import { useState } from "react";
import ContactForm from "../ContactForm/ContactForm";

/**
 * PhotographerHeader component
 *
 * Displays the photographer’s profile information (name, location, tagline, and portrait)
 * and includes a "Contactez-moi" button that opens a contact modal.
 *
 * Props:
 * - photographer: {
 *     name: string,
 *     city: string,
 *     country: string,
 *     tagline: string,
 *     portrait: string
 *   }
 */
export default function PhotographerHeader({ photographer }) {
    // State to control the visibility of the contact modal
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <section className={styles.photographerHeader}>
            
            {/* Photographer’s basic information */}
            <div className={styles.photographerPresentation}>
                <h1 className={styles.photographerName}>{photographer.name}</h1>
                <h2 className={styles.photographerLocation}>
                    {photographer.city}, {photographer.country}
                </h2>
                <p className={styles.photographerTagline}>{photographer.tagline}</p>
            </div>

            {/* "Contactez-moi" button to open the contact form modal */}
            <div className={styles.contactButtonWrapper}>
                <button
                    className={styles.contactButton}
                    onClick={() => setIsModalOpen(true)}
                >
                    Contactez-moi
                </button>
            </div>

            {/* Photographer’s portrait displayed with Next.js <Image> optimization */}
            <div className={styles.portraitWrapper}>
                <Image 
                    src={"/assets/" + photographer.portrait}
                    width={200}
                    height={200}
                    className={styles.photographerPortrait}
                    alt={"Photo de " + photographer.name}
                />
            </div>

            {/* Contact form modal (conditionally rendered based on isModalOpen) */}
            <ContactForm
                name={photographer.name}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </section>
    );
}
